import $ from 'jquery';
import rimg from '@pixelunion/rimg-shopify';
import twitterFetcher from '@pixelunion/twitter-fetcher';

export default class DynamicTwitter {
  constructor(section) {
    this.$el = $(section.el);
    this.$tweetContainer = $('[data-tweet-content]', this.$el);
    this.$tweetDate = $('[data-tweet-date]', this.$el);
    this.$contentPlaceholder = $('[data-tweet-content-placeholder]', this.$el);

    this.settings = section.data;
    const onboarding = this.settings.onboarding;
    const username = this.settings.username;

    if (onboarding || !username) {
      return;
    }

    rimg.watch(this.$tweetContainer[0]);
    this.$tweetContainer.one('rimg:enter', () => {
      twitterFetcher.fetch({
        profile: { screenName: username },
        maxTweets: 1,
        enableLinks: true,
        showUser: true,
        showTime: true,
        showRetweet: false,
        dataOnly: true,
        customCallback: tweets => this._renderTweet(tweets),
        showInteraction: false,
        useEmoji: true,
      });
    });
  }

  _renderTweet(tweets) {
    if (!tweets || !tweets.length) {
      return;
    }

    const tweet = tweets[0];
    const time = tweet.time;
    const content = tweet.tweet;

    if (this.$tweetContainer.length) {
      this.$contentPlaceholder.fadeOut(() => {
        this.$tweetContainer.html(content);
        this.$contentPlaceholder.remove();
      });
    }

    if (this.$tweetDate.length) this.$tweetDate.html(time);
  }
}
